import React from "react";
import SectionTeam from "../../SectionTeam";
import CARD_DATA from "./data"

class SectionTeamDirectory extends React.Component {
  constructor() {
    super();

    this.state = {
        TeamSection: CARD_DATA,
      };
  }

  render() {
    return (
      <>
        {this.state.TeamSection.map(({ ...otherSectionProps }) => (
          <SectionTeam {...otherSectionProps} />
        ))}   
      </>
    );
  }
}

export default SectionTeamDirectory;
